var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 3.7526H0.916667C0.673552 3.7526 0.440394 3.84918 0.268486 4.02109C0.0965773 4.193 0 4.42616 0 4.66927C0 4.91239 0.0965773 5.14554 0.268486 5.31745C0.440394 5.48936 0.673552 5.58594 0.916667 5.58594H1.83333V22.0859C1.83333 22.5722 2.02649 23.0385 2.3703 23.3823C2.71412 23.7261 3.18044 23.9193 3.66667 23.9193H18.3333C18.8196 23.9193 19.2859 23.7261 19.6297 23.3823C19.9735 23.0385 20.1667 22.5722 20.1667 22.0859V5.58594H21.0833C21.3264 5.58594 21.5596 5.48936 21.7315 5.31745C21.9034 5.14554 22 4.91239 22 4.66927C22 4.42616 21.9034 4.193 21.7315 4.02109C21.5596 3.84918 21.3264 3.7526 21.0833 3.7526ZM18.3333 22.0859H3.66667V5.58594H18.3333V22.0859ZM5.5 1.0026C5.5 0.759489 5.59658 0.526331 5.76849 0.354423C5.94039 0.182515 6.17355 0.0859375 6.41667 0.0859375H15.5833C15.8264 0.0859375 16.0596 0.182515 16.2315 0.354423C16.4034 0.526331 16.5 0.759489 16.5 1.0026C16.5 1.24572 16.4034 1.47888 16.2315 1.65079C16.0596 1.82269 15.8264 1.91927 15.5833 1.91927H6.41667C6.17355 1.91927 5.94039 1.82269 5.76849 1.65079C5.59658 1.47888 5.5 1.24572 5.5 1.0026Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.5d811cd103f4ebbd92fd1a45bbcaf5e6.svg";
export { ForwardRef as ReactComponent };